import React ,{useState} from 'react'
import './new_paid_media_dashboard.css'
import { getImgSrc } from "../../../../helpers/getImgSrc"
import { GoPeople } from "react-icons/go";
import DashboardSocialMediaMetricsCard from '../../../../components/client/dashboard/new_dashboard/DashboardSocialMediaMetricsCard';
import { getSvgIcons } from '../../../../helpers/getReactIcons';
import { LeadsBarChart } from '../../../../components';
import LineChart from '../../../../components/client/dashboard/LineChart';



const NewPaidMediaDashboard = ({
    total,

    paid_media,
    dashboardData

},

) => {
    let date = new Date()
    const [selectedTab,setSelectedTab]=useState('Campaigns')



      const adsortedMetrics = dashboardData?.graph_data?.length > 0
        ? [...dashboardData.graph_data].sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
        : [];


     const  ad_graph_data = {
        labels: adsortedMetrics.map((data) =>
          new Date(data?.start_date).toLocaleString('default', { month: 'short', year: 'numeric' })
        ),
        datasets: [
          {
            label: 'Clicks',
            data: adsortedMetrics.map((data) => data?.total_clicks),
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
          },
          {
            label: 'Impressions',
            data: adsortedMetrics.map((data) => data?.total_impressions),
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
          },
          {
            label: 'Spent',
            data: adsortedMetrics.map((data) => data?.total_spent),
            borderColor: 'rgba(255, 205, 86, 0.2)',
            backgroundColor: 'rgba(255, 205, 86, 0.2)',
          },
        ],
      };
      


        const campaignsortedMetrics = dashboardData?.campaigns_graph_data?.length > 0
        ? [...dashboardData.campaigns_graph_data].sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
        : [];


     const  campaign_graph_data = {
        labels: campaignsortedMetrics.map((data) =>
          new Date(data?.start_date).toLocaleString('default', { month: 'short', year: 'numeric' })
        ),
        datasets: [
          {
            label: 'Clicks',
            data: campaignsortedMetrics.map((data) => data?.clicks),
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
          },
          {
            label: 'Impressions',
            data: campaignsortedMetrics.map((data) => data?.impressions),
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
          },
          {
            label: 'Spent',
            data: campaignsortedMetrics.map((data) => data?.spent),
            borderColor: 'rgba(255, 205, 86, 0.2)',
            backgroundColor: 'rgba(255, 205, 86, 0.2)',
          },
        ],
      };

   


    const headerDashboardDataCards = [
        {
            heading: 'Impressions',
            value: dashboardData?.metrics_data?.total_impressions ?? 0,
            value_desc: '',
            logo_background_color: '#efebf8',
            logo_name: 'eye'
        },
        {
            heading: 'Clicks',
            value:  dashboardData?.metrics_data?.total_clicks ?? 0,
            value_desc: '',
            logo_background_color: '#fce7f3',
            logo_name: 'line_graph'
        },
        {
            heading: 'CTR',
            value:  dashboardData?.metrics_data?.total_ctr ?? 0,
            value_desc: '',
            logo_background_color: '#dbeafe',
            logo_name: 'bar_chart'
        },
        {
            heading: 'Cost',
            value:  dashboardData?.metrics_data?.total_spend ?? 0,
            value_desc: '',
            logo_background_color: '#dcfce7',
            logo_name: 'dollar'
        }
    ]

    const campaignMetricsData=[
        {
            metric_name:'Campaign',
            metric_value: dashboardData?.campaign_data?.total_campaigns ?? 0,
            text_color:"#912bd0",
            background_color:"#faf5ff"
        },
        {
            metric_name:'Ad Groups',
            metric_value: dashboardData?.campaign_data?.total_ad_groups ?? 0,
            text_color:"#5d7ae7",
            background_color:"#eff6ff"
        },
            {
            metric_name:'Ads',
            metric_value:dashboardData?.campaign_data?.total_ads ?? 0,
            text_color:"#428749",
            background_color:"#f0fdf4"
        },
            {
            metric_name:'Keywords',
            metric_value:dashboardData?.campaign_data?.total_keywords ?? 0,
            text_color:"#ca9a6b",
            background_color:"#fffbeb"
        }
    ]





    return (
        <div className='dashboard_container'>

            <section className='paid_social_connected_accounts_section'>
                <div className="paid_social_connected_accounts_wrapper">
                    <div className="paid_social_connected_accounts_wrapper_border">

                    </div>
                    <div className="paid_social_connected_accounts_wrapper_top">
                        <div className='paid_media_connected_accounts_wrapper_top_container'>
                            <div className="paid_media_connected_accounts_wrapper_top_container_top">
                                <div className='paid_media_connected_accounts_wrapper_top_container_top_logo'>
                                  {getSvgIcons('document')}

                                </div>
                                <div className='paid_media_connected_accounts_wrapper_top_container_top_heading_text'>
                                    <div>
                                        
                                    </div>
                                    <h3>{dashboardData?.account_details?.account_name ?? "---------------"}</h3>
                                   { dashboardData?.account_details?.account_name &&
                                    <div className='badge'>
                                        <span>Active</span>
                                    </div>}
                                </div>
                          
                             </div>
                         
                              <div className="paid_media_connected_accounts_wrapper_top_container_bottom">
                                 <div className='paid_media_connected_accounts_wrapper_top_container_bottom_container'>
                                    <div>
                                       {getSvgIcons('document',{color:"#9da2ab"})}
                                       <span>Total Spend</span>
                                       <p>{dashboardData?.metrics_data?.total_spend ?? 0}</p>
                                    </div>
                                      <div>
                                       {getSvgIcons('clock',{color:"#9da2ab"})}
                                       <span>Last Updated</span>
                                       <p>{dashboardData?.account_details?.last_updated ?? "---------"}</p>
                                     </div>

                                 </div>

                              </div>
                         
                        </div>
                          
                 

                    </div>
                    <div className="paid_social_connected_accounts_wrapper_bottom">
                       <div className=' paid_media_metrics_details_container'>
                        {campaignMetricsData?.map((data)=>{
                            return <div className='paid_media_metrics_details_card' style={{backgroundColor:data?.background_color}}>
                             <p style={{color:data?.text_color}}>{data?.metric_name}</p>
                             <h4>{data?.metric_value}</h4>

                          </div>
                        })}
                     

                       </div>
                    
                   


                    </div>

                </div>

            </section>



            <section className='dashboard_header_section'>
                <div className="header_overview_metrics_wrapper">

                    <div className="header_overview_metrics_wrapper_top">
                        <div className='header_overview_metrics_wrapper_top_heading' >
                            <div className='header_overview_metrics_wrapper_top_logo' >
                                <img src={getImgSrc('reports')} alt="" />
                            </div>
                            <div className='header_overview_metrics_wrapper_top_heading_text'>
                                <h3 className=''>Overview</h3>
                                <span></span>
                            </div>


                        </div>


                    </div>

                    <div className="header_overview_metrics_wrapper_bottom">
                        {headerDashboardDataCards?.map((data) => {
                            return <div className="header_overview_metrics_card">
                                <div className='header_overview_metrics_card_top'>
                                    <h5 className='overview_metrics_card_heading'>{data?.heading}</h5>
                                    <div className='rounded rounded-circle overview_metrics_card_logo d-flex justify-content-center align-items-center p-1' style={{ backgroundColor: data?.logo_background_color }}>
                                        {/* <img src={getImgSrc(data?.logo_name)} alt="" height={20} className='m-2' /> */}
                                        {getSvgIcons(data?.logo_name,{width:'1.35rem',height:'auto'})}
                                    </div>
                                </div>
                                <div className='header_overview_metrics_card_bottom'>
                                    <h3>{data?.value}</h3>
                                    <span>{data?.value_desc}</span>
                                </div>

                            </div>
                        })}

                    </div>
                </div>



            </section>

            {/* tabs section */}
            <section className='tab_section_container'>
                <div className="tab_section_wrapper">
                    <div className='tab_section_wrapper_top'>
                        <div className='tab_section_wrapper_top_container'>
                        {['Campaigns','Ads'].map((tab)=>{
                            return <div onClick={()=>setSelectedTab(tab)} className={`tab ${selectedTab===tab?"tab_active":""}`}>
                                <span>{tab}</span>
                            </div>

                        })}
                     
                         

                        </div>

                    </div>
                       <div className='tab_section_wrapper_bottom'>
                        <div className='tab_section_wrapper_bottom_content_container'>
                            {/* {selectedTab==="Performance" && (
                                <div className='performance_content_container'>
                                     <div className='performance_metrics_card'>
                                        <div className='performance_metrics_card_top'>
                                          <h3>Performance Over Time</h3>
                                        </div>
                                        <div className='performance_metrics_card_bottom'>
                                            <LeadsBarChart />

                                        </div>

                                    </div>
                                    <div className='performance_metrics_card'>
                                        <div className='performance_metrics_card_top'>
                                          <h3>Performance Over Time</h3>
                                        </div>
                                        <div className='performance_metrics_card_bottom'>
                                            <LeadsBarChart />

                                        </div>

                                    </div>
                                 
                                 </div>
                            )} */}
                            {selectedTab==="Campaigns" && (
                                <div className='campaigns_content_container'>
                                    <div className='performance_metrics_card'>
                                        <div className='performance_metrics_card_top'>
                                          <h3>Google Campaigns</h3>
                                        </div>
                                        <div className='performance_metrics_card_bottom'>
                                             <LineChart graph_data={campaign_graph_data} title="Clicks / Impressions / Spent" />

                                        </div>

                                    </div>


                                </div>
                            )}
                                 {selectedTab==="Ads" && (
                                <div className='ads_content_container'>
                                             <div className='performance_metrics_card'>
                                        <div className='performance_metrics_card_top'>
                                          <h3>Google Ads</h3>
                                        </div>
                                        <div className='performance_metrics_card_bottom'>
                                           <LineChart graph_data={ad_graph_data} title="Clicks / Impressions / Spent" />

                                        </div>

                                    </div>


                                </div>
                            )}

                        </div>
                        


                      </div>

                </div>


            </section>



        </div>
    )
}

export default NewPaidMediaDashboard